export const WEEK_DAY_COUNT = 7;

export const MONTH_DAY_COUNT = 35;

export const WEEK_MIN_HEIGHT = 8 * 15.75;
